import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { DND_MIME } from "@/components/canvas/PricelistPanel";

/** Accepts a catalog line dragged from the price list; highlights while hovering. */
export function DropZone({ onDrop, children, className, testId, as: Tag = "div" }) {
  const [over, setOver] = useState(false);
  const has = (e) => Array.from(e.dataTransfer?.types || []).includes(DND_MIME);
  return (
    <Tag className={cn("relative transition-[box-shadow,background-color]", over && "bg-[hsl(var(--brand-soft))] shadow-[inset_0_0_0_2px_hsl(var(--primary)/0.35)]", className)} data-testid={testId} data-drop={over ? "1" : "0"}
      onDragEnter={(e) => { if (has(e)) { e.preventDefault(); setOver(true); } }} onDragOver={(e) => { if (has(e)) { e.preventDefault(); e.dataTransfer.dropEffect = "copy"; } }} onDragLeave={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setOver(false); }}
      onDrop={(e) => { if (!has(e)) return; e.preventDefault(); setOver(false); try { onDrop(JSON.parse(e.dataTransfer.getData(DND_MIME))); } catch { /* not ours */ } }}>
      {children}
    </Tag>
  );
}
